import styled from 'styled-components'

export const TabContainer = styled.div`
  display: flex;
  flex-direction: row;
  ${(props) => props.theme.container};
  padding: 4px;
`

export const Tab = styled.div<{ active: boolean; textContent: string; fullWidth?: boolean }>`
  position: relative;
  width: ${(props) => (props.fullWidth ? '100%' : 'auto')};
  cursor: pointer;
  padding: 10px 12px;
  border-radius: 12px;
  background-color: ${(props) =>
    props.active ? props.theme.colorOrange : props.theme.transparent};
  color: transparent;

  ::after {
    content: '${(props) => props.textContent}';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    white-space: nowrap;
    font-weight: ${(props) => (props.active ? 'bold' : '400')};
    color: ${(props) =>
      props.active ? props.theme.colorTextOnBrandBlack : props.theme.inactiveTabColor};
  }
`

export const SecondaryTab = styled.div<{ active: boolean; textContent: string }>`
  position: relative;
  width: 100%;
  cursor: pointer;
  padding: 10px 12px;
  background-color: ${(props) =>
    props.active ? `${props.theme.colorOrange}30` : props.theme.transparent};
  color: ${(props) => (props.active ? props.theme.colorOrange : props.theme.greyText)};
  border-bottom: ${(props) =>
    props.active ? `1px solid ${props.theme.colorOrange}` : '1px solid #6A6A6A'};
  text-align: center;

  &:first-child {
    border-top-left-radius: 12px;
  }
  &:last-child {
    border-top-right-radius: 12px;
  }
`

export const SectionTabContainer = styled.div`
  display: flex;
  flex-direction: row;
`
